import { render } from "./NavbarComp.vue?vue&type=template&id=29a3c4d2&scoped=true&ts=true"
import script from "./NavbarComp.vue?vue&type=script&lang=ts"
export * from "./NavbarComp.vue?vue&type=script&lang=ts"

import "./NavbarComp.vue?vue&type=style&index=0&id=29a3c4d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a3c4d2"]])

export default __exports__